import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
import { useFormik } from "formik";
import Select from "react-dropdown";
import { useAddMood, useUpdateMood } from "../../../queryHooks";
import { moodSchema } from "../../../validations/moodsValidations";
import { useStore } from "../../../zustand/store";
import CS from "../../../services/commonService";

//  Component starts
const AddUpdate = ({ moodData, onCloseModal, refetchMoods }) => {
	const setLoading = useStore((state) => state.setLoading);
	//	Pre-defined values
	if (isEmpty(moodData)) moodData = { title: "" };
	const statusOptions = [
		{ value: 1, label: "Active" },
		{ value: 0, label: "Inactive" },
	];
	//	State values
	const [emojiPicker, setEmojiPicker] = useState(false);
	const [formData, setFormData] = useState({
		label: "",
		is_active: "",
		emoji: "",
	});

	useEffect(() => {
		if (moodData) {
			setFormData({
				label: moodData.label,
				is_active: statusOptions.find(
					(option) => option.value === moodData.is_active
				),
				emoji: moodData.emoji,
			});
		}
	}, [moodData, statusOptions]);

	/***********************
	 * Add categories
	 ***************************/

	const {
		mutateAsync: addMoodAsync,
		error: errorAddMood,
		data: dataAddMood,
		isLoading: addMoodAsyncLoading,
	} = useAddMood();

	useEffect(() => {
		if (dataAddMood) {
			if (dataAddMood.status === "success") {
				onCloseModal();
				refetchMoods();
				CS.showSuccessMessage(dataAddMood.message);
			} else if (dataAddMood.status === "fail") {
				CS.showErrorMessage(dataAddMood.message);
			}
		}
	}, [dataAddMood]);

	useEffect(() => {
		if (errorAddMood) {
			CS.showErrorMessage(errorAddMood.response?.data?.message);
		}
	}, [errorAddMood]);

	/******************************************************************************************
    @Purpose    :   Update categories
    *******************************************************************************************/

	const {
		mutateAsync: updateMoodAsync,
		error: errorUpdateMood,
		data: dataUpdateMood,
		isLoading: updateMoodAsyncLoading,
	} = useUpdateMood();

	useEffect(() => {
		if (dataUpdateMood) {
			if (dataUpdateMood.status === "success") {
				onCloseModal();
				refetchMoods();
				CS.showSuccessMessage(dataUpdateMood.message);
			} else if (dataUpdateMood.status === "fail") {
				CS.showErrorMessage(dataUpdateMood.message);
			}
		}
	}, [dataUpdateMood]);

	useEffect(() => {
		if (errorUpdateMood) {
			CS.showErrorMessage(errorUpdateMood.response?.data?.message);
		}
	}, [errorUpdateMood]);

	useEffect(() => {
		setLoading(addMoodAsyncLoading || updateMoodAsyncLoading);
	}, [addMoodAsyncLoading, updateMoodAsyncLoading]);

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: moodSchema,
		enableReinitialize: true,
		onSubmit: (value) => {
			let body = {};
			body = {
				...body,
				...(value.label !== moodData.label && { label: value.label.trim() }),
				...(!!value.is_active?.value !== moodData.is_active && {
					is_active: !!value.is_active?.value,
				}),
				...(value.emoji !== moodData.emoji && { emoji: value.emoji }),
			};
			if (moodData.id) {
				updateMoodAsync({
					moodId: moodData.id,
					body,
				});
			} else {
				addMoodAsync(body);
			}
		},
	});

	return (
		<div className="modal-dialog modal-dialog-scrollable m-0 w-100">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">
						{" "}
						{moodData.id ? "Update Mood" : "Add New Mood"}
					</h5>
				</div>
				<div className="notification-form modal-body card profile-card password-modal">
					<div className="row">
						<div className="col-md-12">
							<form onSubmit={(event) => handleSubmit(event)}>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label" htmlFor="title">
											Label<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<input
												className="form-control"
												type="text"
												id="label"
												name="label"
												placeholder="Enter label"
												value={values.label}
												onChange={handleChange}
											/>
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.label && touched.label ? errors.label : null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={values.is_active}
												onChange={(option) => {
													let event = {
														target: { name: "is_active", value: option },
													};
													handleChange(event);
												}}
												options={statusOptions}
											/>
										</div>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.is_active && touched.is_active
													? errors.is_active
													: null}
											</span>
										</div>
									</div>
								</div>
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Emoji<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<input
												readOnly
												className="form-control cursor-pointer"
												type="text"
												id="emoji"
												name="emoji"
												placeholder="Select an emoji"
												value={values.emoji}
												onClick={() => setEmojiPicker(!emojiPicker)}
											/>
											{emojiPicker && (
												<EmojiPicker
													width="100%"
													height="300px"
													preload={true}
													onEmojiClick={(e) => {
														handleChange({
															target: { name: "emoji", value: e.emoji },
														});
														setEmojiPicker(false);
													}}
												/>
											)}
											<div className="error-message-password">
												<span className="text-danger error-msg d-block mb-2">
													{errors.emoji && touched.emoji ? errors.emoji : null}
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="mt-5 text-right">
									<button className="btn btn-primary" type="submit">
										{moodData.id ? "Update" : "Add"}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
